<template>
  <div>
    <div class="md:w-1/2 w-full p-1">
            <vs-input
                placeholder="Search"
                class="w-full"
                v-model="search"
                @keyup="searchFun"
                style="width: 100%"
              />
      </div>
          <vs-button
          color="danger"
          v-if="selected.length > 1"
          @click="deleteAllSelectedSMS"
          type="filled"
          >Bulk Delete</vs-button
        >
            <ag-grid-vue 
        ref="agGridTable"
        @row-selected="CellvalueSelectDeselect"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :style="{ minHeight: SMSLogData.length * 48 + 75 + 'px' }"
        :gridOptions="gridOptions"
         :defaultColDef="defaultColDef"
        :animateRows="true"
        :floatingFilter="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :columnDefs="columnDefs"
        :rowData="SMSLogData"
        rowSelection="multiple"
        @grid-ready="onGridReady"
       
      />
      <!--  @sortChanged="sortFun" -->
      <div class="sm:flex justify-between items-center">
        <ItemsPerTableDropdown
          tableName="sms"
          @change="(pageLimit) => pageLimitSet = pageLimit"
        />
        <pagination
          :meta="query_page"
          @page-change="handlePageChange"
          class="cstm_pagination"
          style="float: right"
        />
      </div>
      <vs-button
        class="compose-btn"
        @click="composeSMS"
        type="filled"
        v-if="checkSendPermission()"
        >Compose SMS</vs-button
      >

      <!-- <vs-sidebar position-right parent="body" :hidden-background="true" default-index="1"  color="primary" class="sidebarx cstm-sidebarx email-sidebar" spacer v-model="smsSidebar">
                <div class="mt-6 flex items-center justify-between px-6">
                    <h4>Compose SMS</h4>
                    <feather-icon icon="XIcon" class="cursor-pointer" @click="handlcreateSidebar" />
                </div>
                <vs-divider class="mb-0" />
                <div class="p-6 pt-2 sidebar-scrollable-form">
                    <br>
                    <label class="block mb-2">Recipients</label>
                    <vs-divider />
                    <ul class="flex">
                      <li> -->
      <!-- {{from_user_type}} -->
      <!-- <vs-radio v-model="from_user_type" vs-name="from_user_type" vs-value="1"> Users &nbsp;&nbsp;</vs-radio>
                        </li>
                      <li><vs-radio v-model="from_user_type" vs-name="from_user_type" vs-value="2"> Clients &nbsp;&nbsp;</vs-radio></li>
                    </ul>
                    <vs-divider />
                    <div class="flex items-center justify-between sms-form">
                        <label><b>To: </b></label>
                        <v-select
                          class="w-full"
                          label="first_name"
                          :reduce="(option) => option.to_user"
                          :options="recipient_list_to_select"
                          v-model="selected_recipient"
                          :clearable="false"
                          data-vv-name="user_list"
                          name="user_list"
                          multiple
                          ></v-select> -->
      <!-- {{recipient_list_to_select}} -->
      <!-- {{selected_recipient}} -->
      <!-- </div>
                    
                    <vs-divider/> -->
      <!-- {{smsBody}} -->
      <!-- <vs-textarea v-model="smsBody" class="w-full mt-5" label="Write SMS" height="200px" />
                    <vs-divider class="m-0" />

                    <vs-button class="mt-4 compose-btns" @click="sendSMS()" radius color="danger" type="gradient" icon="send" size="large"></vs-button>
              
                    
                </div>
            </vs-sidebar> -->

      <div class="full-cstm-sidebar mt-107" :class="{ open: smsSidebar }">
        <div class="mt-6 flex items-center justify-between px-6">
          <h4>Compose SMS</h4>
          <feather-icon
            icon="XIcon"
            class="cursor-pointer"
            @click="handlcreateSidebar"
          />
        </div>
        <vs-divider class="mb-0" />
        <div class="p-6 pt-2 sidebar-scrollable-form">
          <br />
          <h5 class="block mb-2">Recipients</h5>
          <ul class="flex">
            <li>
              <vs-checkbox v-model="user_recipient">Users </vs-checkbox>
            </li>

            <li>
              <vs-checkbox v-model="client_recipient">Clients </vs-checkbox>
            </li>

            <!-- <li>
                          <vs-checkbox v-model="custom_user_recipient">Custom </vs-checkbox>
                       </li> -->
          </ul>
          <vs-divider />
          <div class="sms-form">
            <h6><b>To : </b></h6>
            <br />
            <div class="user_recipient" v-if="user_recipient">
              <label>Users</label>
              <v-select
                class="w-full"
                :getOptionLabel="
                  (item) => `${item.first_name} ${item.last_name}`
                "
                :reduce="(option) => option.to_user"
                :options="recipient_user_list"
                v-model="selected_user_recipient"
                :clearable="false"
                data-vv-name="user_list"
                name="user_list"
                multiple
              ></v-select>
              <!-- {{recipient_user_list}} -->
              <!-- {{selected_user_recipient}} -->
            </div>

            <div class="client_recipient" v-if="client_recipient">
              <vs-divider />
              <label>Clients </label>
              <v-select
                class="w-full"
                :getOptionLabel="
                  (item) => `${item.first_name} ${item.last_name}`
                "
                :reduce="(option) => option.to_user"
                :options="recipient_client_list"
                v-model="selected_client_recipient"
                :clearable="false"
                data-vv-name="user_list"
                name="user_list"
                multiple
              ></v-select>
              <!-- {{recipient_client_list}} -->
              <!-- {{selected_client_recipient}} -->
            </div>
          </div>

          <!-- {{smsBody}} -->
          <vs-textarea
            v-model="smsBody"
            class="w-full mt-5"
            label="Write SMS"
            height="200px"
          />

          <div class="sms-action-btns">
            <vs-button
              class="mt-4 compose-btns"
              @click="sendSMS()"
              radius
              color="primary"
              type="filled"
              icon="send"
              size="large"
            ></vs-button>
          </div>
        </div>
      </div>
      <div class="bg-overlay"></div>
    
  </div>
</template>

<script>
import cellRendereImage from '@/views/pages/sms/cellRenderSmsImage.vue'

import Vue from 'vue'
import deleteSMSComponent from '@/views/pages/sms/deleteSMS.vue'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/common/pagination'
import Bell from './Bell'
import Editor from '@tinymce/tinymce-vue'
import vSelect from 'vue-select'
import {
  fetch_user_list as fetch_user_client_list,
  fetchSMSLog,
  sendSMS,
  deleteSMS
} from '@/api/communication'
import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'

export default {
  name: 'SMS',
  components: {
    Bell,
    editor: Editor,
    vSelect,
    AgGridVue,
    Pagination,
    deleteSMSComponent,
    Vue,
    cellRendereImage
  },
  mixins: [PermissionMiddleware],

  data: () => ({
    search:'',
    pageLimitSet: null,
    defaultColDef: {
      sortable: true,
      resizable: true,
      suppressMenu: true
      // autoHeight: true
    },
    sorting_obj: {
      field_type: '',
      attribute: '',
      direction: ''
    },
    columnDefs: [],
    gridOptions: {
      accentedSort: true
    },
    gridApi: null,
    user_recipient: true,
    client_recipient: false,
    smsSubject: '',
    smsBody: '',
    image_url: '',
    textarea: '',
    example_image_upload_handler: '',
    from_user_type: '1',
    selected_user_recipient: [],
    selected_client_recipient: [],
    sendSMSToUsers: [],
    selected: [],
    log: [],
    smsSidebar: false,
    recipient_user_list: [],
    recipient_client_list: [],
    localContentValue: '',
    recipient_list_to_select: [],
    SMSLogData: [],
    recipient_type: false,
    EmailInboxData_new_message_count: '',
    showBtn: false,
    query_page: {
      total: '',
      limit: 10,
      has_next: false,
      current_page: 1,
      next_page_url: null,
      previous_page_url: ''
    }
  }),
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Communication', 'sms')
    }
  },
  methods: {
    searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.handlePageChange(1)
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    paginationPageSize () {
      return this.pageLimitSet
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api

      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes()
        this.selected = selecttedNode.map((node) => node.data)
      } else {
        this.selected = []
      }
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)

      return selectedData
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    handlePageChange (page) {
      if (!this.pageLimitSet) return

      this.selected.length = 0
      this.query_page.current_page = page
      this.fetchSMSLog()
    },
    getAllRecipients (smsListData) {
      // eslint-disable-next-line no-unused-vars
      smsListData.forEach(function (value, key) {
        // eslint-disable-next-line no-unused-vars
        value.allRecipients = ''
        value.allRecipients_admin_staff = ''
        value.allRecipients_clients = ''
        let allRecipientsArr_admin_staff = []
        let allRecipientsArr_clients = []
        value.to_admin_or_staff_users.forEach(function (value1, key2) {
          allRecipientsArr_admin_staff = value.to_admin_or_staff_users.map(
            (value1) => {
              if (value1.user !== null) {
                return `${value1.user.first_name} ${value1.user.last_name}`
              }
            }
          )
        })
        value.to_client_users.forEach(function (value1, key2) {
          allRecipientsArr_clients = value.to_client_users.map((value1) => {
            if (value1.user !== null) {
              return `${value1.client_user.first_name} ${value1.client_user.last_name}`
            }
          })
        })
        value.allRecipients = allRecipientsArr_admin_staff
          .concat(allRecipientsArr_clients)
          .join(', ')
      })
    },
    //-------- Function to fetch SMS --------
    async fetchSMSLog () {
      const customer_id = localStorage.getItem('customer_id')
      const payload = {
        search:this.search
      }
      const data = await fetchSMSLog(customer_id, this.query_page.current_page, this.pageLimitSet, payload)
      //
      this.SMSLogData = data.data.data.sms
      this.query_page = data.data.data.meta
      this.getAllRecipients(this.SMSLogData)
    },

    //------- Functions for deleting SENT/INBOX/DRAFT emails START -------
    async deleteSMS (sms_id) {
      const customer_id = localStorage.getItem('customer_id')
      const payload = {
        ids: [sms_id]
      }
      // eslint-disable-next-line no-unused-vars
      const data = await deleteSMS(customer_id, payload)
      //
      this.fetchSMSLog()
    },

    //------- Functions for deleting all selected SMS from all list -------
    async deleteAllSelectedSMS () {
      const customer_id = localStorage.getItem('customer_id')
      const payload = {
        ids: this.selected
      }
      // eslint-disable-next-line no-unused-vars
      const delete1 = await deleteSMS(customer_id, payload)
      this.$vs.notify({
        title: 'Success',
        text: 'SMS deleted successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 3000
      })
      this.fetchSMSLog()
      this.selected = []
    },
    //------- Functions for deleting SENT/INBOX/DRAFT emails END -------

    async fetch_user_client_list (type) {
      //
      //

      try {
        this.$vs.loading()
        const customer_id = localStorage.getItem('customer_id')
        const data = await fetch_user_client_list(customer_id, type)
        //
        if (type === 'User') {
          this.recipient_user_list = data.data.data.results
          this.recipient_user_list_cc = data.data.data.results
        } else if (type === 'Client') {
          this.recipient_client_list = data.data.data.results
          this.recipient_client_list_cc = data.data.data.results
        }
      } catch (error) {
      } finally {
        this.$vs.loading.close()
      }
    },
    composeSMS () {
      this.smsSidebar = true
    },
    handlcreateSidebar () {
      this.smsSidebar = false
    },
    clearComposeSMS () {
      this.from_user_type = '1'
      this.smsSubject = ''
      this.smsBody = ''
      this.selected_user_recipient = []
      this.selected_client_recipient = []
      this.client_recipient = false
      this.sendSMSToUsers = []
      this.smsSidebar = false
    },
    getSelectedRecipientObject (selected_recipient, to_user_type, is_root_user) {
      for (let i = 0; i < selected_recipient.length; i++) {
        this.sendSMSToUsers.push({
          to_user_id: selected_recipient[i],
          to_user_type,
          is_root_user
        })
      }
    },
    async sendSMS () {
      //To Recipients
      if (this.user_recipient) {
        this.getSelectedRecipientObject(this.selected_user_recipient, 1, true)
      }
      if (this.client_recipient) {
        this.getSelectedRecipientObject(
          this.selected_client_recipient,
          2,
          true
        )
      }
      const payload = {
        from_user_type: this.from_user_type,
        is_parent_thread: true,
        body: this.smsBody,
        to_users: this.sendSMSToUsers
      }
      //
      //

      try {
        //this.$vs.loading()
        const customer_id = localStorage.getItem('customer_id')
        // eslint-disable-next-line no-unused-vars
        const data = await sendSMS(customer_id, payload)

        this.clearComposeSMS()
        this.fetchSMSLog()

        this.$vs.notify({
          title: 'Success',
          text: 'SMS Sent Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {
        let errorText = ''
        if (error.data.errors.body) {
          errorText = 'Body is required'
        } else if (error.data.errors.to_users) {
          errorText = 'To users is required'
        }

        this.$vs.notify({
          title: 'Error',
          text: errorText,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } finally {
        //this.$vs.loading.close()
      }
    },
    rowSelect (details_page_type, sms_id) {
      //setTimeout(function(){
      this.$router.push({
        name: 'Email_Details',
        params: { sms_id, details_page_type }
      })
    }
  },
  mounted () {
    this.fetch_user_client_list('User')
    this.fetch_user_client_list('Client')

    this.columnDefs = [
      {
        headerName: '',
        width: 60,
        field: 'isSelected',
        filter: false,
        checkboxSelection: (params) => {
          return true
        },
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: 'Recipients',
        field: 'allRecipients',
        width: 180,
        cellRendererFramework:'cellRendereImage'
      },
      {
        headerName: 'Body',
        field: 'body',
        width: 180,
        sortable: false,
        valueFormatter: params => `${params.data.body.replace(/(.{20})..+/, '$1…') } `
      },
      {
        headerName: 'Action',
        sortable: false,
        width: 100,
        cellRendererFramework: Vue.extend(deleteSMSComponent),
        CellRendererParams: {
          deleteSMS: (id) => this.deleteSMS(id)
        }
      }
    ]
  },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    },
    from_user_type () {
      this.fetch_user_lists()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.smsSidebar = false
    setTimeout(() => {
      next()
    }, 0)
  }
}
</script>

<style>
.unread {
  background-color: #fff5ec;
  font-weight: 500;
}
.new {
  background-color: transparent !important;
  font-weight: 500;
}
.email-table tr {
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
  position: relative;
}
.email-table tr:hover .delete-btn {
  display: block;
  top: 0;
}
.email-card {
  position: relative;
}
.compose-btn,
.delete-all-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  /* background: #FF9F43 !important; */
  /* box-shadow: 0 8px 25px -8px rgba(255, 159, 67, 1) !important; */
}
.delete-all-btn {
  right: 100px;
}
.delete-btn {
  display: none;
  position: absolute;
  /* top: 10px; */
  right: 30px;
  padding: 0 10px;
}
.delete-btn:hover {
  background: #e9eaea;
  border-radius: 50%;
}
.delete-btn .feather-icon {
  margin: 8px 0;
}
.delete-btn svg {
  width: 18px;
  color: #727373;
}
.email-sidebar .vs-sidebar {
  max-width: 400px;
  margin-top: 107px;
}
.email-sidebar .sidebar-scrollable-form {
  height: calc(100% - 175px);
  overflow-y: auto;
  overflow-x: hidden;
}
.sms-form input,
.sms-form input:focus {
  border: none !important;
  box-shadow: none;
}
.sub-line {
  border: none !important;
  height: 40px;
}

.compose-btns {
  display: inline;
  margin-right: 15px;
}

.sms-action-btns {
  text-align: right;
}
.email-cc {
  margin-top: 15px;
}

@media (max-width: 360px) {
  .email-sidebar .vs-sidebar {
    max-width: 100%;
  }
}
</style>